// @flow
/* eslint-disable no-template-curly-in-string */

export default {
  All: 'Tất cả',
  AllDocuments: 'Tất cả tài liệu',
  Any: 'Bất kì',
  Today: 'Hôm nay',
  Yesterday: 'Hôm qua',
  LastWeek: 'Tuần trước',
  LastMonth: 'Tháng trước',
  DateFrom: 'Từ',
  DateTo: 'ĐẾN',
  DateRange: 'Phạm vi ngày',
  NeverViewed: 'Chưa bao giờ được xem hoặc thay đổi kể từ lần xem cuối cùng',
  AddedLastLogin: 'Đã thêm hoặc thay đổi kể từ lần đăng nhập cuối cùng',
  GlobalNetworkErrorMessage:
    'Đã xảy ra sự cố với mạng. Hãy thử lại hoặc liên hệ với bộ phận hỗ trợ.',
  GlobalIntermediateProxyErrorMessage:
    'Mạng của bạn đã chặn yêu cầu gửi tới phòng dữ liệu này. Hãy liên hệ với bộ phận CNTT của bạn.',
  GlobalUnexpectedErrorWithIdMessage:
    'Có vấn đề với phòng dữ liệu của bạn. Trích dẫn mã này \u003c[ErrorId]\u003e cho nhóm Dịch vụ khách hàng của chúng tôi.',
  GlobalUnexpectedErrorMessage:
    'Có vấn đề với phòng dữ liệu của bạn. Vui lòng liên hệ với nhóm Dịch vụ Khách hàng của chúng tôi.',
  NoRecordsFound: 'Không có dữ liệu được tìm thấy.',
  Save: 'Lưu',
  Print: 'In',
  ViewAs: 'Xem bằng quyền',
  Documents: 'Các tài liệu',
  Date: 'Ngày',
  HideEmptyFolders: 'Ẩn các thư mục trống',
  Search: 'Tìm kiếm',
  Actions: 'Hành động',
  Filter: 'Lọc',
  Self: 'Bạn',
  Allowed: 'Cho phép',
  Denied: 'Từ chối',
  PleaseEnterValidToDate: 'Vui lòng nhập một giá trị hợp lệ cho đến nay.',
  PleaseEnterValidFromDate: 'Vui lòng nhập ngày hợp lệ.',
  SavingAllowed: 'Cho phép lưu',
  SavingDenied: 'Lưu bị từ chối',
  PrintingAllowed: 'Cho phép in ấn',
  PrintingDenied: 'Việc in bị từ chối',
  ChooseLanguage: 'Chọn ngôn ngữ',
  EditProfile: 'Chỉnh sửa hồ sơ',
  DataRooms: 'Phòng dữ liệu',
  Administration: 'Sự quản lý',
  MyAccount: 'Tài khoản của tôi',
  Profile: 'Hồ sơ',
  Logout: 'Đăng xuất',
  Loading: 'Đang tải',
  Success: 'Thành công',
  Disabled: 'Tàn tật',
  Ok: 'Được rồi',
  And: 'Và',
  Demo: 'Thử nghiệm',
  TenderSubmissionsStart: 'Bắt đầu quá trình gửi',
  TenderSubmissionsOverdue:
    'Quá trình gửi đã kết thúc. Tài liệu bạn tải lên bây giờ sẽ bị đánh dấu là muộn.',
  TenderSubmissionsClose: 'Quá trình gửi đã kết thúc.',
  Later: 'Sau đó',
  StartNow: 'Bắt đầu bây giờ',
  StartSubmissionDialogTitle: 'Bắt đầu quá trình gửi',
  StartSubmissionDialogContent:
    'Các nhà thầu sẽ được thông báo rằng họ có thể tải lên và xem tài liệu.' +
    'Nhóm nội bộ của bạn không thể truy cập tài liệu trong quá trình gửi.',
  StartSubmissionDialogCloseDateContent:
    'Quá trình gửi kết thúc vào ${closeDate}.',
  SubmissionInformationIsIncomplete: 'Thông tin gửi không đầy đủ.',
  BidderTeamsHaveNotBeenInvitedOrHaveBeenRemoved:
    'Các nhà thầu chưa được mời hoặc đã bị loại bỏ.',
  InviteBidderTeams: 'Mời nhà thầu',
  UpdateSecuritySettings: 'Cập nhật cài đặt bảo mật',
  UpdateTheirSecuritySettings: 'Cập nhật cài đặt bảo mật của họ.',
  OnTimeSubmission: 'Nộp hồ sơ đúng thời hạn',
  LateSubmission: 'Hồ sơ nộp muộn',
  DeleteAllDocuments: 'Xóa tất cả các tài liệu nộp',
  Manage: 'Quản lý',
  ManageSubmissions: 'Quản lý bài nộp',
  NotStarted: 'Chưa bắt đầu',
  Closed: 'Đã đóng',
  ExtraTime: 'Trong hiệp phụ',
  Open: 'Mở',
  CreateTheStructureAndSetTheCloseDateForBidderSubmissions:
    'Tạo cấu trúc và đặt ngày kết thúc để gửi nhà thầu.',
  AddSubmissionWindow: 'Thêm cửa sổ gửi bài',
  BiddersDoNotHaveAccessToAddSubmissionsSingular:
    '1 nhà thầu không có quyền truy cập để thêm bài nộp.',
  BiddersDoNotHaveAccessToAddSubmissionsPlural:
    'Người đặt giá thầu ${totalBidders} không có quyền truy cập để thêm nội dung gửi.',
  BulkRedactionCurrentDocumentNumberOfTotal:
    '${currentDocumentNumberĐóngCurlyBrace of ${totalDocsCountĐóngCurlyBrace tài liệu',
  BulkRedactionMarksToRedact: '${selectedMarksCount} các mục cần chỉnh sửa',
  BulkRedactionMarksRedacted:
    '${redactionMarksCountĐóngCurlyBrace các mục được xử lý lại',
  BulkRedactionSkipAndNext: 'Bỏ qua tài liệu',
  BulkRedactionSkipAndFinish: 'Bỏ qua và hoàn tất việc biên tập lại',
  BulkRedactionSaveAndNext: 'Lưu và tiếp theo tài liệu',
  BulkRedactionSaveAndFinish: 'Lưu và hoàn tất việc biên tập lại',
  BulkRedactionRedactAllRemainingDocuments:
    'Chỉnh sửa lại tất cả các tài liệu ${documentsRemaining}',
  BulkRedactionCancel: 'Hủy bỏ',
};
